const AOS = require('aos');
const $ = require('jquery');
const _ = require('lodash');

require('popper.js');
require('bootstrap');
require('slick-carousel');
require('simplebar');
require('magnific-popup');

window.jQuery = $;

$(document).ready(function(){
  // Burger menu.
  function openMenu(open) { $('#burger').toggleClass('open', open); $('#navigation-mobile ul').toggleClass('open', open); }
  var open = false;
  $('#burger').click(function() { open = !open; openMenu(open); });

  // Active class.
  // $('#header .nav > li > a[href]').each(function() { if (this.href == window.location.href) { $(this).addClass('active'); } }); 

  // Show toggle.
  $('.toggle').on('click', function(){
    var button = $(this);
    button.parent('p').parent('div').parent('div').prev('div').children('.hide').toggleClass('d-none');
    button.parent('p').parent('div').parent('div').toggleClass('off').toggleClass('on');
    button.toggleClass('off').toggleClass('on');
    if (button.hasClass('off')) { button.children('span').text('Show more'); } else { button.children('span').text('Hide'); }
    setTimeout(function(){ AOS.init(); }, 500);
  });

  // News carousel.
  $('.carousel-news').slick({
    arrows: false,
    dots: true,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          centerMode: true,
          centerPadding: '128px',
        },
      },
      {
        breakpoint: 1440,
        settings: {
          centerMode: true,
          centerPadding: '256px',
        }
      }
    ],
  });

  // Nav tabs.
  $('.nav-tabs li a').on('click', function(){
    setTimeout(function(){ AOS.init(); }, 500);
  });

  // Card fix.
  function cardFix() {
    if ($('[class^="card-"]').length) {
      $('[class^="card-"]').each(function(){
        var card = $(this);
        var title = card.find('h2');
        var title_height = title.outerHeight();
        var height = title_height + 40;
        $(card).find('.d-flex').css('top', 'calc(100% - ' + height + 'px)');
      });
    }
  }
  cardFix();
  $(window).on('resize', function(){ cardFix(); });

  // Placeholder fix.
  if ($('#loginform').length) {
    $('.login-username input').attr('placeholder', 'Username *');
    $('.login-password input').attr('placeholder', 'Password *');
  }

  // Dropdown fix.
  function dropdownFix() {
    $('.dropdown-sub').each(function(){
      var dropdown = $(this);
      var dropdownOffset = dropdown.offset().left;
      var windowWidth = $(window).width();
      var maxWidth = windowWidth - dropdownOffset;
      dropdown.css('max-width', maxWidth + 'px');
    });
  }
  dropdownFix();
  $(window).on('resize', function(){ dropdownFix(); });

  // Magnific gallery.
  if ($('.gallery').length){
    $('.gallery').magnificPopup({
      delegate: 'div > a',
      type: 'image',
      gallery: {
        enabled: true
      }
    });
  }

  // AOS.
  setTimeout(function(){
    $('body').addClass('loaded');
    setTimeout(function(){ AOS.init(); }, 500);
    $(window).on('resize', function(){ AOS.init(); }, 500);
  }, 1000);
});

// Google Maps.
(function($) {
  function new_map($el) {
    var $markers = $el.find('.marker');
    var args = {
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [{"featureType":"administrative.land_parcel","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]}],
      zoom: 16,
    };
    var map = new google.maps.Map($el[0], args);
    map.markers = [];
    $markers.each(function(){
      add_marker($(this), map);
    });
    center_map(map);
    return map;
  }

  function add_marker($marker, map) {
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
    var icon = {url: ''+$marker.attr('data-icon')+'', scaledSize: new google.maps.Size(48, 48)};
    var marker = new google.maps.Marker({
      icon: icon,
      map: map,
      position: latlng,
    });
    map.markers.push(marker);
    if($marker.html()){
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html()
      });
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker);
      });
    }
  }

  function center_map(map) {
    var bounds = new google.maps.LatLngBounds();
    $.each( map.markers, function(i, marker){
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });
    if( map.markers.length == 1 ) {
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    } else {
      map.fitBounds(bounds);
    }
  }

  var map = null;
  $(document).ready(function(){
    $('.map').each(function(){
      map = new_map($(this));
    });

    $('.nav-tabs a').on('shown.bs.tab', function (e) {
      var click = $(this);
      var anchor = click.attr('href');
      var pane = $(anchor);
      var map = $(pane).find('.map-alt');
      if(!$(click).hasClass('map-created')){
        map = new_map(map);
      }
      $(click).addClass('map-created');
    })
  });
})($);